// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"zR-z","smallCardRow":"AR-z","largeCardRow":"BR-z","productSearchRow":"CR-z","curatedRow":"DR-z"};